import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import linkPropType from '@/custom-prop-types/link';
import { Button } from '@/design-system/atoms/Button';
import { ComplexCardCarousel } from '@/design-system/molecules/ComplexCardCarousel';

const CareersCarousel = ({
    title,
    cta,
    theme,
    limit = 4,
    queryUrl,
    jobDetailsBaseUrl,
    ...props
}) => {
    const [data, setData] = useState(null);
    const parsedLimit = parseInt(limit, 10);
    const remapData = useCallback(
        (data) => {
            return data.map((item) => ({
                eyebrow: item?.Category,
                title: item?.Title,
                subtitle: item?.PrimaryLocation
                    ? item.PrimaryLocation.replace(/, United States/g, '')
                    : '',
                featuredIcon: item?.BeFirstToApplyFlag
                    ? 'clock'
                    : item?.TrendingFlag
                      ? 'trending-up'
                      : null,
                featuredContent: item?.BeFirstToApplyFlag
                    ? 'Be the first to apply'
                    : item?.TrendingFlag
                      ? 'Trending'
                      : null,
                cta: {
                    href: `${jobDetailsBaseUrl}${item?.Id}`,
                },
            }));
        },
        [jobDetailsBaseUrl],
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(queryUrl);

                const json = await response.json();
                const remappedData = remapData(json.items[0]?.requisitionList);
                const limitedData = remappedData.slice(0, parsedLimit);
                setData(limitedData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [limit, queryUrl, remapData, parsedLimit]);

    if ((!data || data.length === 0) && !props.isInEditor) {
        return null;
    }
    return (
        <div {...props}>
            <ComplexCardCarousel
                title={title}
                cta={{ ...cta, buttonStyle: Button.STYLE.PRIMARY }}
                carouselItems={data}
                theme={theme}
                analyticsComponentTitle="careers_carousel"
            />
        </div>
    );
};

CareersCarousel.propTypes = {
    // The title of the carousel
    title: PropTypes.string,
    // The call to action button
    cta: linkPropType,
    // The theme of the carousel
    theme: PropTypes.oneOf(['light', 'medium']),
    // The number of items to display in the carousel
    limit: PropTypes.number,
    // The URL to fetch the data from
    queryUrl: PropTypes.string,
    // The base URL for the job details page
    jobDetailsBaseUrl: PropTypes.string,
};

CareersCarousel.defaultProps = {
    title: 'Featured Jobs',
    theme: 'medium',
};

export default CareersCarousel;
